import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';

import { AuthenticationService } from '../../login/authentication.service'

import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../../shared/showmenu.service';

import { UnixtimeService } from '../../../shared/unixtime.service';
import { BeepService } from '../../../shared/beep.service';
import { VibrateService } from '../../../shared/vibrate.service';

import { NgxIndexedDBService } from 'ngx-indexed-db';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MenucontentService } from '../../../shared/menucontent.service';
import { UploadcounterService } from '../../../shared/uploadcounter.service';

@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.css'],
})
export class TypeComponent implements OnInit {
  qrForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  stage_type: string;

  showmenu: boolean;

  showThemePink=true;

  qrResultString: any;
  timing_json: any;

  gotoQRcode() {
    var stage_type = localStorage.getItem('global_stage_type');
    this.router.navigate(['/scan/' + stage_type]);
  }

  onSubmit(formDirective) {
    this.submitted = true;

    if (!this.qrForm.valid) {
      return;
    }

    /*
    var item = {
      type: 'time', 
      client_id: localStorage.getItem("global_client_id"),
      device_id: localStorage.getItem("global_device_id"),
      client_pin: localStorage.getItem("global_client_pin"),
      mass_start_id: 0,
      stage_type: localStorage.getItem("global_stage_type"),
      race_number: qr_code, 
      tagged_time: unix_time_now(),
      user_name: localStorage.getItem("global_user_name"),
    };
*/
    this.BeepService.beep();
    this.VibrateService.vibrate();
    this.qrResultString = this.qrForm.controls.qrnumber.value;
    var unix_time = this.UnixtimeService.unixtime();

    this.timing_json = {
      type: 'time',
      client_id: localStorage.getItem('global_client_id'),
      device_id: localStorage.getItem('global_device_id'),
      client_pin: localStorage.getItem('global_client_pin'),
      mass_start_id: 0,
      stage_type: localStorage.getItem('global_stage_type'),
      race_number: this.qrResultString,
      tagged_time: unix_time,
      user_name: localStorage.getItem('global_user_name'),
    };

    this.dbService
      .add('timingmobi', {
        json: this.timing_json,
      })
      .subscribe((key) => {
        //console.log('key: ', key);

        //this.openSnackBar('QR code: '+this.qrResultString, 'OK')
        //this.qrForm.controls.qrnumber.setValue('')
        this.qrForm.patchValue({
          qrnumber: '',
          // formControlName2: myValue2 (can be omitted)
        });

        // https://stackoverflow.com/questions/34608361/how-to-reset-form-validation-on-submission-of-the-form-in-angular-2
        formDirective.resetForm();
        //setTimeout(() => this.qrForm.controls.qrnumber.focus());

        this.openSnackBar(this.qrResultString, 'OK');
        this.dbService.count('timingmobi').subscribe((peopleCount) => {
          this.UploadcounterService.changeUploadTotal(peopleCount);
        });

      });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  constructor(
    private menutitle: MenutitleService,
    private AuthenticationService: AuthenticationService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private ShowmenuService: ShowmenuService,
    private UnixtimeService: UnixtimeService,
    private dbService: NgxIndexedDBService,
    private _snackBar: MatSnackBar,
    private BeepService: BeepService,
    private VibrateService: VibrateService,
    private MenucontentService: MenucontentService, 
    private UploadcounterService: UploadcounterService, 
  ) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in()
    this.AuthenticationService.save_current_route()
    
    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.route.paramMap.subscribe((params) => {
      this.stage_type = params.get('stage_type');
      this.menutitle.changeMenutitle(this.stage_type);

      if (this.stage_type=='Individual Start'){
        this.menutitle.showMenupink(false);
        this.showThemePink=false;
      } else {
        this.menutitle.showMenupink(true);
        this.showThemePink=true;
      }
  
      //console.log('Theme: '+this.showThemePink)
    });

    //this.menutitle.showMenupink(true);

    /*
    if (this.stage_type == 'Individual Start') {
      this.menutitle.showMenupink(false);
    } else {
      this.menutitle.showMenupink(true);
    }
    */

    this.qrForm = this.formBuilder.group({
      qrnumber: ['', [Validators.required]],
    });

    this.route.paramMap.subscribe((params) => {
      this.stage_type = params.get('stage_type');

      localStorage.setItem('global_stage_type', this.stage_type);
      this.menutitle.changeMenutitle(this.stage_type);
    });

    //this.qrInput.nativeElement.focus();

    localStorage.setItem('global_input_method', 'keyboard');
  }
}
